import React, { ChangeEvent, InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  type: 'text' | 'number' | 'email' | 'password';
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  value: string;
  required?: boolean;
  errorText?: string | null;
  toggleInputType?: () => void;
  passwordIcon?: JSX.Element;
  withPassword?: boolean;
}

const Input: React.FC<InputProps> = (props) => {
  return (
    <>
      <div>
        {props.label && (
          <label className='input-label'>
            {props.label}{' '}
            {props.required && <span className='text-[red]'>*</span>}
          </label>
        )}
        <div className='relative flex flex-col'>
          <input
            {...props}
            type={props.type}
            value={props.value}
            onChange={props.onChange}
            onBlur={props.onBlur}
            className={props.errorText ? 'input-error' : 'input'}
          />

          {props.errorText ? (
            <span className='text-[red] text-sm'>{props.errorText}</span>
          ) : null}

          {props.withPassword && (
            <div
              className='absolute top-2 right-2 cursor-pointer'
              onClick={props.toggleInputType}
            >
              {props.passwordIcon}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Input;
